import {
  LayoutGrid,
  MessageSquare,
  Columns3,
  CalendarCheck,
  Users,
  Wallet,
  BarChart3,
  Boxes,
  Settings,
  HelpCircle,
  Rocket,
  Menu as MenuIcon,
  type LucideIcon,
} from 'lucide-react';
import type { Permission } from '@valiosascrm/shared';

/** Sober DS sidebar nav config. Routes are canonical root paths. */
export interface NavEntry {
  id: string;
  label: string;
  to: string;
  icon: LucideIcon;
  count?: number;
  permission?: Permission;
  permissionsAny?: Permission[];
  brand?: boolean;
}

export interface NavSection {
  title?: string;
  items: NavEntry[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    items: [
      { id: 'dashboard', label: 'Início', to: '/dashboard', icon: LayoutGrid },
      { id: 'agendamentos', label: 'Agenda', to: '/agendamentos', icon: CalendarCheck, permission: 'appointments:read' },
      { id: 'pacientes', label: 'Clientes', to: '/pacientes', icon: Users, permission: 'patients:read' },
      { id: 'inbox', label: 'Conversas', to: '/inbox', icon: MessageSquare, permission: 'inbox:read' },
      { id: 'financeiro', label: 'Financeiro', to: '/financeiro', icon: Wallet, permission: 'financial:read' },
      { id: 'mensagens', label: 'Mensagens', to: '/mensagens', icon: MessageSquare, permissionsAny: ['message-templates:update', 'campaigns:read', 'inbox:write'] },
    ],
  },
  {
    title: 'Mais',
    items: [
      { id: 'resultados', label: 'Resultados', to: '/resultados', icon: BarChart3, permission: 'analytics:view' },
      { id: 'crm', label: 'Funil de clientes', to: '/crm', icon: Columns3, permission: 'leads:read' },
      { id: 'estoque', label: 'Estoque', to: '/estoque', icon: Boxes, permission: 'inventory:read' },
      // Classe A: sem gate — o hub já mostra só os tiles que a role alcança, e
      // toda role tem ao menos "Meu perfil". Gate aqui escondia o caminho inteiro.
      { id: 'configuracoes', label: 'Configurações', to: '/config', icon: Settings },
    ],
  },
];

export const NAV_ONBOARDING: NavEntry = {
  id: 'primeiros-passos',
  label: 'Primeiros Passos',
  to: '/primeiros-passos',
  icon: Rocket,
  permission: 'settings:manage',
};

export const NAV_MENU: NavEntry = {
  id: 'menu',
  label: 'Menu',
  to: '/menu',
  icon: MenuIcon,
};

export const NAV_HELP: NavEntry = { id: 'ajuda', label: 'Ajuda', to: '/ajuda', icon: HelpCircle };

export const NAV_ALL: NavEntry[] = [NAV_ONBOARDING, ...NAV_SECTIONS.flatMap((s) => s.items), NAV_MENU, NAV_HELP];

// Story 62.2: a rotina tem a mesma hierarquia para todas as roles. As permissões
// continuam filtrando itens individualmente no Sidebar.
export function getNavSections(role: string | null | undefined): NavSection[] {
  void role;
  return NAV_SECTIONS;
}
